// src/pages/MobileDashboard.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import shapeImage from "../assets/images/shape.webp";

const MobileDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex flex-col items-center justify-center p-6">
      
      <div className="flex flex-col items-center justify-center w-full max-w-md space-y-8">
        
        {/* Welcome Section with Spheres */}
        <div className="flex items-center justify-center w-full gap-4">
          {/* Left Sphere */}
          <div className="w-16 h-16 flex-shrink-0">
            <img src={shapeImage} alt="Decoration" className="w-full h-full" />
          </div>

          {/* Welcome Text */}
          <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-green-500 to-blue-500"
              style={{ fontFamily: "'Barlow', sans-serif", fontWeight: 700 }}>
            Welcome
          </h1>

          {/* Right Sphere */}
          <div className="w-16 h-16 flex-shrink-0">
            <img src={shapeImage} alt="Decoration" className="w-full h-full" />
          </div>
        </div>

        {/* Text Box */}
        <div className="w-full border-2 border-purple-500/50 rounded-lg p-6 bg-black/60">
          <p className="text-purple-400 text-sm leading-relaxed text-center" 
             style={{ fontFamily: "'Press Start 2P', monospace" }}>
            Welcome to my little space.
          </p>
        </div>

        {/* CV Button */}
         <button
            onClick={() => navigate("/CV")}
            className="w-full max-w-xs py-3 px-6 border-2 border-purple-500 bg-black text-purple-400 rounded-lg 
                        hover:bg-purple-500/20 hover:border-purple-400 hover:text-white 
                        transition-all duration-300 font-semibold"
            >
            View CV
            </button>

        {/* Footer Note */}
        <p className="text-xs text-gray-500 text-center mt-4">
          Desktop experience recommended (1280px+)
        </p>
      </div>
    </div>
  );
};

export default MobileDashboard;